
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { User } from '@angular/fire/auth';

import { Session } from './session.service';
import { environment } from '../../environments/environment';



@Injectable()
export class UserService {
  private authService = inject(AuthenticationService);

  isDependent = true;
  progress = 0;
  sessionId = '';
  loadedSession: Session | null = null;
  isDemo = true; // Set to true when Faber is used
  isAdmin = environment.isAdminPreview;
  schoolId = '';
  userId = '';
  cbUserId = 'guest'; // College Board User ID returned from legacy application after user logs in to College Board
  cbPersonId = ''; // College Board Person ID extracted from JWT token after user logs in to College Board

  isAidQuiz = false; // Set to true when the aidquiz school is selected
  efcMethodology: 'FM' | 'IM' | 'BOTH' = 'BOTH';

  // Authentication state - now using the dedicated AuthenticationService
  user: Observable<User | null>;

  constructor() {
    // Use the authentication service's user observable
    this.user = this.authService.user$;

    // Update userId when user changes
    this.user.subscribe(user => {
      if (user) {
        this.userId = user.uid;
      }
    });
  }
}
